import React from 'react';

import { SelectListFilter } from '@sandtech-hub-monorepo/ui-kit';
import { useGeoPicker } from './picker';

export const CityPicker = ({
  countryCode,
  stateCode,
  selected,
  handleOnSelect,
}: {
  countryCode?: string;
  stateCode?: string;
  selected?: string;
  handleOnSelect?: (item: { value: string; label: string }) => void;
}) => {
  const { getCities } = useGeoPicker();

  return (
    <SelectListFilter
      items={
        countryCode && stateCode ? getCities(countryCode, stateCode) : undefined
      }
      defaultValue={selected}
      handleChange={handleOnSelect}
    />
  );
};
